module.exports = __webpack_public_path__ + "img/50.cc9a5e19.jpg";